module.exports = __webpack_public_path__ + "static/media/bird_page19.492a1eb1.png";